import { render, staticRenderFns } from "./uso.vue?vue&type=template&id=43ba2b47"
import script from "./uso.vue?vue&type=script&lang=js"
export * from "./uso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports